import { render } from "./CatalogBrand.vue?vue&type=template&id=344d40f3"
import script from "./CatalogBrand.vue?vue&type=script&lang=js"
export * from "./CatalogBrand.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__